import type { TourTargetCatalogEntry } from './types'

/** Targets for the `customize-invoice-code` virtual tour. */
export const CUSTOMIZE_INVOICE_CODE_TOUR_TARGETS = {
  themeEditorEditCode: {
    key: 'themeEditorEditCode',
    route: '/app/themes/edit/:themeId',
    selector: '[data-tour="theme-editor-edit-code"]',
    description: 'Edit code link in the theme editor header',
    featureArea: 'Templates',
    routeMatch: 'prefix',
    waitTimeoutMs: 60_000,
    interactionMode: 'interactive',
    advanceOnPath: '/app/themes/code/',
    advanceOnPathMatch: 'prefix',
  },
  themeCodeLiquidTab: {
    key: 'themeCodeLiquidTab',
    route: '/app/themes/code/:themeId',
    selector: '[data-tour="theme-code-file-dropdown"]',
    description: 'Liquid file dropdown in the code editor toolbar',
    featureArea: 'Templates',
    routeMatch: 'prefix',
    waitTimeoutMs: 30000,
  },
  themeCodeStylesTab: {
    key: 'themeCodeStylesTab',
    route: '/app/themes/code/:themeId',
    selector: '[data-tour="theme-code-file-dropdown"]',
    description: 'Liquid file dropdown (open to switch to {{styles}})',
    featureArea: 'Templates',
    routeMatch: 'prefix',
    waitTimeoutMs: 30000,
    advanceOnClick: '[data-tour="theme-code-styles-tab"]',
  },
  themeCodePreviewButton: {
    key: 'themeCodePreviewButton',
    route: '/app/themes/code/:themeId',
    selector: '[data-tour="theme-code-more-actions"]',
    description:
      'More actions menu in the code editor toolbar (Preview, Format, Validate…)',
    featureArea: 'Templates',
    routeMatch: 'prefix',
    waitTimeoutMs: 30000,
    advanceOnClick: '[data-tour="theme-code-preview"]',
  },
  themeTemplateGuide: {
    key: 'themeTemplateGuide',
    route: '/app/themes/code/:themeId',
    selector: '[data-tour="theme-template-guide"]',
    description: 'Template guide link in the code editor header',
    featureArea: 'Templates',
    routeMatch: 'prefix',
    waitTimeoutMs: 30000,
  },
} as const satisfies Record<string, TourTargetCatalogEntry>

export type CustomizeInvoiceCodeTourTargetKey = keyof typeof CUSTOMIZE_INVOICE_CODE_TOUR_TARGETS

export const CUSTOMIZE_INVOICE_CODE_TOUR_TARGET_KEY = {
  themeEditorEditCode: 'themeEditorEditCode',
  themeCodeLiquidTab: 'themeCodeLiquidTab',
  themeCodeStylesTab: 'themeCodeStylesTab',
  themeCodePreviewButton: 'themeCodePreviewButton',
  themeTemplateGuide: 'themeTemplateGuide',
} as const satisfies { readonly [K in CustomizeInvoiceCodeTourTargetKey]: K }
